import React, { Component } from 'react'
import { base } from '../../base';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'

class UserSessionScreen extends Component {
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) {
        super(props);

        this.state = {
          currentSession: {},
          loadingScreenOn: false,
          currentQuestion: 0,
          answers: {},
          final: false,
        };
    }

    componentWillMount() {
      this.currentSessionRef = base.listenTo(`currentSession`, {
        context: this,
        then(currentSession){
          const { cookies } = this.props;
          if(cookies.get(currentSession.id) === "Answered"){
            this.setState({
              currentSession: currentSession,
              currentQuestion: 0,
              final: true,
            })
          } else {
            this.setState({
              currentSession: currentSession,
              currentQuestion: 0,
              final: false,
            })
          }
        },
        onFailure(error) {
          alert(error)
        }
      });
      this.loadingScreenOnRef = base.bindToState('loadingScreenOn', {
        context: this,
        state: 'loadingScreenOn',
      })
    }

    componentWillUnmount() {
      base.removeBinding(this.loadingScreenOnRef);
      base.removeBinding(this.currentSessionRef);
    }

    submitResponses(answers, currentQuestion){
      var session = this.state.currentSession;
      const { cookies } = this.props;
      var vm = this;
      base.push('sessionResponses', {
        data: {answers: answers, sessionId: session.id},
        then(err){
          if(!err){
            cookies.set(session.id, 'Answered', { path: '/', maxAge:86400 });
            vm.setState({
              final: true,
              currentQuestion: currentQuestion,
              answers: answers,
            })
          } else {
            alert(err);
          }
        }
      })
    }

    onClickAnswer(questionId, answerLocation){
      if(this.props.connection === false){
        confirmAlert({
          title: 'Poor Connection',
          message: 'Check your connection and try again!',
          confirmLabel: "",
          cancelLabel: 'Okay',
        })
        return;
      }
      var currentQuestion = this.state.currentQuestion;
      var session = this.state.currentSession;
      if(currentQuestion + 1 !== session.questions.length){
        currentQuestion = currentQuestion + 1;
      }
      var vm = this;
      var answers = this.state.answers;
      answers[questionId] = answerLocation.toString();
      if(this.state.currentQuestion === session.questions.length - 1){
        vm.submitResponses(answers, currentQuestion);
      } else {
        this.setState({
          currentQuestion: currentQuestion,
          answers: answers,
        })
      }
    }

    render() {
      var currentQuestion = this.state.currentQuestion;
      var currentSession = this.state.currentSession;
      var sessionName = "No Session";
      var question = null;
      var questionKey = "";
      var questionText = "";
      var answersArray = [];
      var questionArray = [];
      var questionArrayLength = null;
      if(Object.keys(currentSession).length > 0){
        sessionName = currentSession.sessionName;
        questionArray = currentSession.questions;
        questionArrayLength = questionArray.length;
        question = questionArray[currentQuestion];
        if(question){
          questionText = question.question;
          questionKey = question.key;
          answersArray = question.answers;
        }
        // this.checkCurrentQuestions(questionArray);
      }
      var final = this.state.final;
      if (final) {
        return this.renderThankYouScreen()
      } else {
        return this.renderBeforeScreen(sessionName, questionText, answersArray, questionKey, questionArrayLength)
      }
    }

    renderThankYouScreen(){
      return(
        <div className="grid-wrapper session">
          <div className="grid-container-holding session">
              <div className="hide-mobile">
                <center>
                  <img width="300px" height="auto" src={require('../../styles/images/global-summit-logo.png')} alt=""/>
                </center>
                <h1>Thank You!</h1>
                <hr/>
                <h1>We appreciate you taking the time to leave us feedback</h1>
              </div>
              <div className="grid-item-holding top-logo">
                  <div className="creator-awards-logo-holding top-text-mobile">
                    <img src={require('../../styles/images/global-summit-logo.png')} alt=""/>
                  </div>
              </div>
              <div className="grid-item-holding top-text">
                  <h2 className="top-text-mobile session">Thank You!</h2>
                  <h3 className="top-text-mobile waiting">We appreciate you taking the time to leave us feedback</h3>
              </div>
              <div className="grid-item-holding middle">
                  <hr className="holding"/>
              </div>
          </div>
        </div>
      )
    }

    renderBeforeScreen(sessionName, questionText, answersArray, questionKey, questionArrayLength){
      return (
        <div>
          {
            this.state.loadingScreenOn ? (
              <div className="grid-wrapper session-not-holding">
                <div className="creator-awards-logo user session">
                  <img src={require('../../styles/images/global-summit-logo.png')}  alt=""/>
                </div>
                <div className="grid-header creator-vote">
                  <h1><span>{questionText}</span></h1>
                </div>
                <div className="grid-container creator-vote">

                    {
                      answersArray.map(function(item,i){
                          return  <div key={i}
                                    className="session-item"
                                    onClick={()=>this.onClickAnswer(questionKey, i)}>
                                    <span>{item}</span>
                                  </div>
                      }, this)
                    }

                </div>
              </div>
            ) : (
                <div className="grid-wrapper session">
                  <div className="hide-mobile" style={{height:'100px'}}></div>
                  <div className="grid-container-holding">
                      <div className="grid-item-holding top-logo">
                          <div className="creator-awards-logo-holding">
                            <img src={require('../../styles/images/global-summit-logo.png')}  alt=""/>
                          </div>
                      </div>
                      <div className="grid-item-holding top-text">
                          <h1><span>Waiting for<br /> feedback to begin</span></h1>
                      </div>
                     <div className="grid-item-holding top-text">
                        <h3 className="top-text-mobile waiting">Waiting for feedback to begin...</h3>
                      </div>
                      {/*
                      <div className="grid-item-holding middle">
                          <hr className="holding"/>
                      </div>
                      <div className="grid-item-holding bottom">
                          <div className="grid-footer">
                              <h1>Go to we.co/summitfb to Vote</h1>
                          </div>
                      </div>

                      <div className="grid-item-holding bottom">
                          <div className="grid-footer">
                              <h1>Go to we.co/summitfb to Vote</h1>
                          </div>
                      </div>*/}
                  </div>
                </div>
            )
          }
        </div>
      );
    }
}

export default withCookies(UserSessionScreen)



// WEBPACK FOOTER //
// ./src/components/sessions/UserSessionScreen.js